import * as ng from 'angular';
import { ArchiSmallServices } from '../../../services/archismall.service';
import { googleAPI } from '../../../third/googleAPI';

class UploadPersonalFilesController implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$rootScope',
        'ArchiSmallServices',
        '$timeout',
        '$uibModalStack',
        '$sce',
        'configuration'
    ];
    private close: any;
    private dismiss: any;

    constructor(
        private $scope: any,
        private $rootScope: any,
        private ArchiSmallServices: ArchiSmallServices,
        private $timeout: ng.ITimeoutService,
        private $uibModalStack: ng.ui.bootstrap.IModalStackService,
        private $sce: any,
        private configuration: any
    ) {
        $scope.tooltips = {
            'identityCard': 'Carica copia a colori fronte/retro del documento d\'identità valido(Carta o Passaporto) del Legale Rappresentante.',
            'fiscalCode': 'Carica copia a colori fronte/retro del Codice Fiscale del Legale Rappresentante.',
            'businessProfile': 'Carica copia a norma della Visura Camerale valida.'
        };
        $scope.disableSaving = false;
        $scope.user = $scope.$parent.$resolve.user;
        $scope.acceptedExtensions = ['pdf', 'jpg', 'png'];
        $scope.identityCardLoading = false;
        $scope.fiscalCodeLoading = false;
        $scope.businessProfileLoading = false;
        $scope.ok = () => {
            this.close();
        };
        let identityCardFileCopy = $scope.user.organizationData.contactPerson.identityCardFile;
        let fiscalCodeFileCopy = $scope.user.organizationData.contactPerson.fiscalCodeFile;
        let businessProfileFileBefore = $scope.user.organizationData.contactPerson.businessProfileFile;

        $scope.cancel = () => {
            $scope.user.organizationData.contactPerson.identityCardFile = identityCardFileCopy === 'Allega copia Carta Identita' ? '' : identityCardFileCopy;
            $scope.user.organizationData.contactPerson.fiscalCodeFile = fiscalCodeFileCopy === 'Allega copia Codice Fiscale' ? '' : fiscalCodeFileCopy;
            $scope.user.organizationData.contactPerson.businessProfileFile = businessProfileFileBefore === 'Allega copia Visura Camerale' ? '' : businessProfileFileBefore;
            this.dismiss({ $value: 'cancel' });
        };

        $scope.uploadFileDescription = 'Clicca qui per allegare il tuo documento.';
        $scope.user.organizationData.contactPerson.identityCardFile = $scope.user.organizationData.contactPerson.identityCardFile === undefined ? '' : $scope.user.organizationData.contactPerson.identityCardFile;
        $scope.user.organizationData.contactPerson.fiscalCodeFile = $scope.user.organizationData.contactPerson.fiscalCodeFile === undefined ? '' : $scope.user.organizationData.contactPerson.fiscalCodeFile;
        $scope.user.organizationData.contactPerson.businessProfileFile = $scope.user.organizationData.contactPerson.businessProfileFile === undefined ||
            $scope.user.organizationData.contactPerson.businessProfileFile === '' ?
            '' : $scope.user.organizationData.contactPerson.businessProfileFile;

        this.cleanModelFromDescription();

        $scope.fiscalCodeFile = '';
        $scope.fiscalCodeFileId = '';
        $scope.fiscalCodeFilePath = '';
        $scope.identityCardFile = '';
        $scope.identityCardFileId = '';
        $scope.identityCardFilePath = '';
        $scope.businessProfileFile = '';
        $scope.businessProfileFileId = '';
        $scope.businessProfileFilePath = '';
        $scope.changedFieldFiscal = false;
        $scope.changedFieldIdentity = false;
        $scope.changedFieldBusinessProfile = false;
        $scope.changedSuccess = false;

        $scope.uploadFileOnGoogleStorageCallback = (dropzoneId, res, filename) => {
            let icon = '';
            let delete_icon = '';
            $scope.extension = filename.split('.').pop().toLowerCase();
            delete_icon = '<a ng-click=\'deleteFile($event)\'><i class=\'fa fa-trash-o fa-2x delete-icon\'></i></a>';

            switch ($scope.extension) {
                case 'pdf':
                    icon = $sce.trustAsHtml('<i class=\'fa fa-file-pdf-o fa-2x\'></i>');
                    break;
                case 'jpg':
                case 'png':
                    icon = $sce.trustAsHtml('<i class=\'fa fa-file-image-o fa-2x\'></i>');
                    break;
                default:
                    icon = $sce.trustAsHtml('<i class=\'fa fa-file-o fa-2x\'></i>');
            }

            if (dropzoneId === 'dropzone-fiscal-code') {
                $scope.user.organizationData.contactPerson.fiscalCodeFile = filename;
                $scope.user.organizationData.contactPerson.fiscalCodeFileId = res.id.split('/')[0] + '/' + res.name;
                $scope.fiscalCodeFile = filename;
                $scope.fiscalCodeFileId = res.id;
                $scope.fiscalCodeFilePath = res.name;
                $scope.icon_fiscal_code = icon;
                $scope.delete_fiscal_code = delete_icon;
                $scope.changedFieldFiscal = true;
            } else if (dropzoneId === 'dropzone-business-profile') {
                $scope.user.organizationData.contactPerson.businessProfileFile = filename;
                $scope.user.organizationData.contactPerson.businessProfileFileId = res.id.split('/')[0] + '/' + res.name;
                $scope.businessProfileFile = filename;
                $scope.businessProfileFileId = res.id;
                $scope.businessProfileFilePath = res.name;
                $scope.icon_business_profile = icon;
                $scope.delete_business_profile_file = delete_icon;
                $scope.changedFieldBusinessProfile = true;
            } else {
                $scope.user.organizationData.contactPerson.identityCardFile = filename;
                $scope.user.organizationData.contactPerson.identityCardFileId = res.id.split('/')[0] + '/' + res.name;
                $scope.identityCardFile = filename;
                $scope.identityCardFileId = res.id;
                $scope.identityCardFilePath = res.name;
                $scope.icon_id_card = icon;
                $scope.delete_id_card_file = delete_icon;
                $scope.changedFieldIdentity = true;
            }

            $scope.id_card_placeholder = '';
            $scope.disableSaving = false;
            this.showHideSpecificLoadingIcon($scope.type);
        };

        $scope.deleteFile = (type) => {
            let inputId = this.getIdByType(type);
            this.deleteInputFile(inputId);
            let dropzoneId = this.getDropzoneIdByType(type);

            if (dropzoneId === 'dropzone-fiscal-code') {
                $scope.user.organizationData.contactPerson.fiscalCodeFileId = '';
                $scope.user.organizationData.contactPerson.fiscalCodeFile = '';
                $scope.fiscalCodeFile = '';
                $scope.fiscalCodeFileId = '';
                $scope.fiscalCodeFilePath = '';
                $scope.icon_fiscal_code = '';
                $scope.delete_fiscal_code = '';
                $scope.changedFieldFiscal = false;
            } else if (dropzoneId === 'dropzone-business-profile') {
                $scope.user.organizationData.contactPerson.businessProfileFileId = '';
                $scope.user.organizationData.contactPerson.businessProfileFile = '';
                $scope.businessProfileFile = '';
                $scope.businessProfileFileId = '';
                $scope.businessProfileFilePath = '';
                $scope.icon_business_profile = '';
                $scope.delete_business_profile_file = '';
                $scope.changedFieldBusinessProfile = false;
            } else {
                $scope.user.organizationData.contactPerson.identityCardFileId = '';
                $scope.user.organizationData.contactPerson.identityCardFile = '';
                $scope.identityCardFile = '';
                $scope.identityCardFileId = '';
                $scope.identityCardFilePath = '';
                $scope.icon_id_card = '';
                $scope.delete_id_card_file = '';
                $scope.changedFieldIdentity = false;
            }
        };

        $scope.updateFiles = () => {
            $scope.files = {};
            if ($scope.fiscalCodeFile !== '') {
                $scope.files.fiscalCode = {
                    'fileName': $scope.user.organizationData.contactPerson.fiscalCodeFile,
                    'fileId': $scope.user.organizationData.contactPerson.fiscalCodeFileId,
                    'changed': fiscalCodeFileCopy !== $scope.user.organizationData.contactPerson.fiscalCodeFile
                };
            }
            if ($scope.identityCardFile !== '') {
                $scope.files.identityCard = {
                    'fileName': $scope.user.organizationData.contactPerson.identityCardFile,
                    'fileId': $scope.user.organizationData.contactPerson.identityCardFileId,
                    'changed': identityCardFileCopy !== $scope.user.organizationData.contactPerson.identityCardFile
                };
            }
            if ($scope.businessProfileFilePath !== '') {
                $scope.files.businessProfile = {
                    'fileName': $scope.user.organizationData.contactPerson.businessProfileFile,
                    'fileId': $scope.user.organizationData.contactPerson.businessProfileFileId,
                    'changed': businessProfileFileBefore !== $scope.user.organizationData.contactPerson.businessProfileFile
                };
            }

            let promise = ArchiSmallServices.updatePersonalFiles($scope.files)
                .then((response: any) => {
                    $scope.changedSuccess = true;
                    $scope.user.organizationData.contactPerson.fiscalCodeFileId = response.organizationData.contactPerson.fiscalCodeFileId;
                    $scope.user.organizationData.contactPerson.fiscalCodeFile = response.organizationData.contactPerson.fiscalCodeFile;
                    $scope.user.organizationData.contactPerson.identityCardFileId = response.organizationData.contactPerson.identityCardFileId;
                    $scope.user.organizationData.contactPerson.identityCardFile = response.organizationData.contactPerson.identityCardFile;
                    $scope.user.organizationData.contactPerson.businessProfileFile = response.organizationData.contactPerson.businessProfileFile;
                    $scope.user.organizationData.contactPerson.businessProfileFileId = response.organizationData.contactPerson.businessProfileFileId;

                }, (error) => {
                    $rootScope.alert('error', error);
                    $scope.cancel();
                });
            return promise;
        };

        $scope.save = () => {
            $scope.identityCardFileRequiredError = $scope.user.organizationData.contactPerson.identityCardFile === undefined ||
                $scope.user.organizationData.contactPerson.identityCardFile === '' ||
                $scope.user.organizationData.contactPerson.identityCardFile === 'Allega copia Carta Identita';

            let data = {
                'user': $scope.user,
                'requiredFieldsMissing': $scope.identityCardFileRequiredError,
                'changed': {
                    'identityCard': identityCardFileCopy !== $scope.user.organizationData.contactPerson.identityCardFile,
                    'fiscalCode': fiscalCodeFileCopy !== $scope.user.organizationData.contactPerson.fiscalCodeFile,
                    'businessProfile': businessProfileFileBefore !== $scope.user.organizationData.contactPerson.businessProfileFile
                }
            };

            this.close({ $value: data });
        };

        $scope.startInputUpload = (type) => {
            let idSelector = this.getIdByType(type);
            $(idSelector).trigger('click');
        };

        $scope.inputUpload = (input, type) => {
            let file = input.files[0];
            if (this.isExtensionAccepted(file)) {
                $scope.type = type;
                this.showHideSpecificLoadingIcon(type);
                $scope.disableSaving = true;
                let username = $scope.user.accountData.email;
                let dropzoneId = this.getDropzoneIdByType(type);
                this.uploadFileOnGoogleStorage(file, username, dropzoneId);
            }
        };



    }

    isExtensionAccepted(file: any) {
        let extension = file.name.split('.').pop().toLowerCase();

        if ($.inArray(extension, this.$scope.acceptedExtensions) === -1) {
            this.$rootScope.alert('warning', 'Il file <b>' + file.name + '</b> non può essere accettato! (I soli formati permessi sono: <b>' + this.$scope.acceptedExtensions.join(', ') + '</b>)');
            return false;
        }

        return true;
    }
    showHideSpecificLoadingIcon(type: any) {
        switch (type) {
            case 'identityCard':
                this.$scope.identityCardLoading = !this.$scope.identityCardLoading;
                break;
            case 'fiscalCode':
                this.$scope.fiscalCodeLoading = !this.$scope.fiscalCodeLoading;
                break;
            case 'businessProfile':
                this.$scope.businessProfileLoading = !this.$scope.businessProfileLoading;
                break;
        }
    }

    deleteInputFile(id: any) {
        let element = ng.element(document.querySelector(id));
        ng.element(element).val(null);
    }



    uploadFileOnGoogleStorage(file: any, username: any, dropzoneId: any) {
        this.insertObject(file, username, dropzoneId);
    }

    insertObject(file: any, username: any, dropzoneId: any) {
        let dropzoneStorageFolder = 'users/' + this.$scope.user.accountData.email + '/personal_files';
        this.ArchiSmallServices.validateGoogleAPIToken(googleAPI.getAccessToken())
            .then((response: any) => {
                googleAPI.insertObject(file, dropzoneId, dropzoneStorageFolder, username, this.$scope.uploadFileOnGoogleStorageCallback);
                this.$rootScope.filesUploadedNumber++;
            }, (error) => {
                this.ArchiSmallServices.getGoogleAPIToken()
                    .then((response: any) => {
                        googleAPI.setAccessToken(response.accessToken);
                        googleAPI.insertObject(file, dropzoneId, dropzoneStorageFolder, username, this.$scope.uploadFileOnGoogleStorageCallback);
                        this.$rootScope.filesUploadedNumber++;
                    }, (error) => {
                        this.$rootScope.alert('error', error);
                        this.$scope.disableSaving = false;
                        this.showHideSpecificLoadingIcon(this.$scope.type);
                    });
            });
    }

    cleanModelFromDescription() {
        if (this.$scope.user.organizationData.contactPerson.identityCardFile === 'Allega copia Carta Identita') {
            this.$scope.user.organizationData.contactPerson.identityCardFile = '';
        }

        if (this.$scope.user.organizationData.contactPerson.fiscalCodeFile === 'Allega copia Codice Fiscale') {
            this.$scope.user.organizationData.contactPerson.fiscalCodeFile = '';
        }

        if (this.$scope.user.organizationData.contactPerson.businessProfileFile === 'Allega copia Visura Camerale') {
            this.$scope.user.organizationData.contactPerson.businessProfileFile = '';
        }
    }

    getIdByType(type: any) {
        let idSelector = '';

        switch (type) {
            case 'identityCard':
                idSelector = '#identity-card-upload';
                break;
            case 'fiscalCode':
                idSelector = '#fiscal-code-upload';
                break;
            case 'businessProfile':
                idSelector = '#business-profile-upload';
                break;
        }
        return idSelector;
    }

    getDropzoneIdByType(type: any) {
        let dropzoneId = '';

        switch (type) {
            case 'identityCard':
                dropzoneId = 'dropzone-id-cards';
                break;
            case 'fiscalCode':
                dropzoneId = 'dropzone-fiscal-code';
                break;
            case 'businessProfile':
                dropzoneId = 'dropzone-business-profile';
                break;
        }
        return dropzoneId;
    }
}

export const UploadPersonalFilesComponent: ng.IComponentOptions = {
    template: require('./upload-personal-files.html'),
    controller: UploadPersonalFilesController,
    bindings: {
        close: '&',
        dismiss: '&'
    }
};




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/registration/upload-personal-files/upload-personal-files.ts